import { Nullable } from "../../common/types/types";
import { APP_MODE, CONFIG_ROLES, IConfigState, IStallMode } from "./types";

const hikinikusUUID = new Set([
	"4a62e3bd-0597-417f-b031-ed3cd3b47ca7",
	"2eeb4204-8f62-4802-955d-c11985288f77",
]);

// Maps a UUID to its brand base path. Order mirrors getDefaultStallMode below
// so a UUID that appears in multiple sets resolves to the same brand consistently.
export const getBrandPath = (uuid: string): string | null => {
	if (!uuid) return null;
	if (hikinikusUUID.has(uuid)) return "/hikiniku";

	return null;
};

// Force stallMode based on domain name in production
const getStallMode = (
	fallbackMode: Nullable<IStallMode>,
	isProduction?: boolean
): Nullable<IStallMode> => {
	if (typeof globalThis === "undefined" || !globalThis.location) {
		return fallbackMode;
	}

	let prodMode = isProduction;

	if (prodMode === undefined) {
		try {
			// Use eval to avoid syntax error during Jest parsing
			prodMode = eval("import.meta.env.MODE") === "production";
		} catch {
			prodMode = false;
		}
	}

	return fallbackMode;
};

const getDefaultStallMode = (): Nullable<IStallMode> => {
	if (typeof globalThis === "undefined" || !globalThis.location) {
		return null;
	}

	const urlParams = new URLSearchParams(globalThis.location.search);
	const uuid = urlParams.get("uuid") ?? "";

	if (uuid.length === 0) return null;
	if (hikinikusUUID.has(uuid)) {
		return IStallMode.HIKINIKU;
	}

	return IStallMode.SOK;
};

export const initialState: IConfigState = {
	user: {
		session_id: "getSessionId",
		role: CONFIG_ROLES.GUEST,
	},
	theme: "light",
	location: {
		id: "",
		name: "Default Location",
		outletid: "outletId",
		description: "Default Description",
	},
	config: {
		stall: { mode: getDefaultStallMode(), name: "", image_url: "", address: [] },
		enable_sok: true,
		takeaway_fee: 0,
		bcrs_deposit_rate: 10,
		VDPfooter: null,
		enableDevTools: true,
	},
	isLoading: false,
	errorMessage: null,
	count: 0,
	stallMode: getDefaultStallMode(),
	appMode: APP_MODE.VIEW,
	inited: false,
	devMode: false,
	adminAccessGranted: false,
	maintenanceAccessGranted: false,
};

export { getStallMode };
